import React from "react";
import "./Footer.css";

const Footer = () => (
  <footer className="footer">
    <div className="container footer__inner">
      <div className="footer__brand">
        <span className="footer__logo">TravelEase</span>
        <p>Multi-stop route ordering, without the guesswork.</p>
      </div>

      <div className="footer__meta">
        <a href="mailto:sandhk20@mcmaster.ca">sandhk20@mcmaster.ca</a>
        <div className="footer__links">
          <a
            href="https://github.com/SandhuKaran"
            target="_blank"
            rel="noreferrer"
          >
            GitHub
          </a>
          <a
            href="https://www.linkedin.com/in/sandhukaran/"
            target="_blank"
            rel="noreferrer"
          >
            LinkedIn
          </a>
        </div>
      </div>
    </div>

    <div className="container footer__base">
      <span>© {new Date().getFullYear()} Karan Sandhu</span>
      <span>Built as a proof of concept</span>
    </div>
  </footer>
);

export default Footer;
